// extracted by css-extract-rspack-plugin
export default {"slider":"xl58RJ","slider-short":"KxAheH","sliderShort":"KxAheH","slider-tall":"q0jVUQ","sliderTall":"q0jVUQ","slider-item":"g1n93w","sliderItem":"g1n93w"};